import api from '../../plugins/api';

// Прайс марки по приказу. Один прайс на марку, всегда открыт на редактирование —
// версий и копий нет. Семантика правил и корзин применения: doscar_back/docs/price-lists.md

// Марки, у которых есть сток приложения, — навигация по прайсам
export const getPriceMarks = () => api.get('/api/crm/prices/marks');

// Всё, что нужно экрану разом: шапка документа, правила, ветки стока, справочники
export const getPriceList = (markId) => api.get(`/api/crm/prices/${markId}`);

export const savePriceMeta = (markId, meta) => api.post(`/api/crm/prices/${markId}/meta`, meta);

// Правила уходят целиком: редактирование дерева локальное, экран присылает итоговый набор
export const savePriceRules = (markId, rules) => api.post(`/api/crm/prices/${markId}/rules`, rules);

// preview=true — посчитать и ничего не менять
export const applyPriceList = (markId, preview) =>
  api.post(`/api/crm/prices/${markId}/apply?preview=${preview ? 'true' : 'false'}`);

export const rollbackPriceList = (batchId) => api.post(`/api/crm/prices/rollback/${batchId}`);

export const getPriceHistory = (markId) => api.get(`/api/crm/prices/${markId}/history`);

// Синхронизация приказов с Google-таблицей: doscar_back/docs/price-sheet-sync.md

// Что сейчас с таблицей, без записи: изменения, ждущие подтверждения, проблемы с подсказками привязок
export const getSheetSyncState = () => api.get('/api/crm/prices/sheet-sync/state');

// dryRun=false записывает и применяет; confirm — ID строк, чьи остановленные изменения подтверждены
export const runSheetSync = ({ dryRun = true, confirm = [] } = {}) =>
  api.post(
    `/api/crm/prices/sheet-sync?dryRun=${dryRun ? 'true' : 'false'}${
      confirm.length ? `&confirm=${encodeURIComponent(confirm.join(','))}` : ''
    }`
  );

// Привязки строк таблицы (по ID) к правилам; { sheetKey, ignore: true } — не синхронизировать строку
export const saveSheetLinks = (links) => api.post('/api/crm/prices/sheet-sync/links', links);

// Все привязанные строки: текст из таблицы, правила приказа и статус «сходится ли»
export const getSheetLinks = () => api.get('/api/crm/prices/sheet-sync/links');

// Снять привязку строки: она вернётся к сопоставлению по названиям
export const deleteSheetLink = (sheetKey) =>
  api.delete(`/api/crm/prices/sheet-sync/links/${encodeURIComponent(sheetKey)}`);

export const getSheetSyncHistory = (limit = 50) => api.get(`/api/crm/prices/sheet-sync/history?limit=${limit}`);

// Вернуться к версии: откатить все применённые запуски после выбранного
export const rollbackToSheetRun = (runId) => api.post(`/api/crm/prices/sheet-sync/rollback-to/${runId}`);

// Автосинхронизация: включена ли (экран перебивает конфиг) и кто последний менял
export const getSheetSyncSettings = () => api.get('/api/crm/prices/sheet-sync/settings');

export const setSheetAutoSync = (autoSync) => api.post('/api/crm/prices/sheet-sync/settings', { autoSync });

export const rollbackSheetRun = (runId) => api.post(`/api/crm/prices/sheet-sync/rollback/${runId}`);
